import { render, staticRenderFns } from "./Sover.vue?vue&type=template&id=3dc2f1f4&scoped=true"
import script from "./Sover.vue?vue&type=script&lang=js"
export * from "./Sover.vue?vue&type=script&lang=js"
import style0 from "./Sover.vue?vue&type=style&index=0&id=3dc2f1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2f1f4",
  null
  
)

export default component.exports